
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-page-header',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <div class="flex flex-col gap-4 mb-6 sm:mb-8 sm:flex-row sm:items-end sm:justify-between">
      <div>
        @if (eyebrow) {
          <p class="text-[11px] font-raleway font-semibold uppercase tracking-widest text-primary/70">
            {{ eyebrow }}
          </p>
        }
        <h1 class="text-3xl lg:text-4xl font-alice text-blue-dark leading-tight mt-1">
          {{ title }}
        </h1>
        @if (subtitle) {
          <p class="text-sm text-gray-500 mt-1 font-raleway max-w-xl">
            {{ subtitle }}
          </p>
        }
      </div>
      <div class="flex flex-wrap gap-2">
        <ng-content></ng-content>
      </div>
    </div>
    `
})
export class AdminPageHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle?: string;
  @Input() eyebrow?: string;
}
